import React, { useState, useContext } from "react";
import styled from "styled-components";
import propic from "../images/profile.jpeg";
import sun from "../images/sun.png";
import moon from "../images/moon.png";
import about from "../images/about-me.png";
import projects from "../images/projects.jpg";
import qual from "../images/qualifications.jpg";
import a1 from "../images/1.png";
import a2 from "../images/2.png";
import a3 from "../images/3.png";
import a4 from "../images/4.png";
import a5 from "../images/5.png";
import a6 from "../images/6.png";
import a7 from "../images/7.png";
import a8 from "../images/8.png";
import a9 from "../images/9.png";
import a10 from "../images/10.png";
import a11 from "../images/11.png";
import a12 from "../images/12.png";
import ThemeContext, { themes } from "./themes";
import Bounce from "react-reveal/Bounce";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import { Link } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import $ from "jquery";
function Header() {
  const [theme, setTheme] = useState(themes.light);
  const [theme1, setTheme1] = useState(themes.light1);
  const [t, st] = useState(moon);
  const [a, sa] = useState(0);

  const [isMobile, setIsMobile] = useState(false);

  $(document).ready(function () {
    $(window).scroll(function () {
      // var x = window.matchMedia("(max-width: 780px)");
      // if (x.matches) {
      //   var a = document.querySelector("#navbarscrollback");
      //   a.style.backgroundColor = "crimson";
      // }

      if (this.scrollY > 20) {
        var a = document.querySelector("#navbarscrollback");
        if (a) {
          a.style.backgroundColor = "crimson";
          a.style.height = "50px";
        }
      } else {
        var a = document.querySelector("#navbarscrollback");
        if (a) {
          a.style.backgroundColor = "transparent";
          a.style.height = "100px";
        }
      }
    });
  });

  const changetheme = () => {
    theme === themes.dark ? setTheme(themes.light) : setTheme(themes.dark);
    theme1 === themes.dark1
      ? setTheme1(themes.light1)
      : setTheme1(themes.dark1);

    if (a == 0) {
      st(sun);
      sa(1);
    } else {
      st(moon);
      sa(0);
    }
    console.log(theme);
  };
  const [posl, chposl] = useState(0);
  const [posr, chposr] = useState(0);
  function move(e) {
    // chposl((e.pageX-25)+"px");
    // chposr((e.pageY-25)+"px");
    // console.log(posl,posr);
    document.querySelectorAll(".layer").forEach((layer) => {
      const speed = layer.getAttribute("data-speed");
      const x = (window.innerWidth - e.pageX * speed) / 30;
      const y = (window.innerHeight - e.pageY * speed) / 40;
      layer.style.transform = `translateX(${x}px)`;
    });
  }

  return (
    <Container onMouseMove={move} style={theme}>
      {theme === themes.dark && (
        <div>
          <img src={a1} data-speed="-5" class="layer imagebacfor" />
          <img src={a2} data-speed="5" class="layer imagebacfor" />
          <img src={a3} data-speed="2" class="layer imagebacfor" />
          <img src={a4} data-speed="6" class="layer imagebacfor" />
          <img src={a5} data-speed="8" class="layer imagebacfor" />
          <img src={a6} data-speed="-2" class="layer imagebacfor" />
          <img src={a7} data-speed="4" class="layer imagebacfor" />
          <img
            src={a8}
            style={{ left: "0px" }}
            data-speed="-5"
            class="layer imagebacfor"
          />
          <img src={a9} data-speed="6" class="layer imagebacfor" />
          <img src={a10} data-speed="-7" class="layer imagebacfor" />
          <img src={a11} data-speed="-5" class="layer imagebacfor" />
          <img src={a12} data-speed="2" class="layer imagebacfor" />
        </div>
      )}
      <Navbar id="navbarscrollback">
        <h2 style={theme1}>PORTFOLIO</h2>

        <ul
          className={isMobile ? "nav-links-mobile" : "nav-links"}
          onClick={() => setIsMobile(false)}
          style={theme1}
        >
          <li className="navv" style={theme1}>
            <a href="#1">
              <span>HOME</span>
            </a>
          </li>
          <li className="navv" style={theme1}>
            <a href="#2">
              <span>ABOUT ME</span>
            </a>
          </li>
          <li className="navv" style={theme1}>
            <a href="#3">
              <span>MY PROJECTS</span>
            </a>
          </li>
          <li className="navv" style={theme1}>
            <a href="mailto:divvelavishnusai@gmail.com">
              <span>CONTACT ME</span>
            </a>
          </li>
          <li className="navv">
            <img
              style={{ color: "white" }}
              src={t}
              onClick={changetheme}
              className="icon"
            />
          </li>
        </ul>

        <button
          onClick={() => setIsMobile(!isMobile)}
          className="mobile-menu-icon"
        >
          {isMobile ? (
            <CloseIcon style={{ width: "30px" }} class="fas fa-times" />
          ) : (
            <MenuIcon style={{ width: "30px" }} class="fas fa-bars" />
          )}
        </button>
      </Navbar>
      <Info style={theme1} id="1">
        <Fade bottom>
          <div style={theme1} className="content">
            <h1 style={theme1}>
              <span>Hello,</span>
            </h1>
            <h1 className="my11" style={theme1}>
              I'm Divvela <span>Vishnu</span> Sai Kumar
            </h1>
            <p style={theme1}>
              I am pursuing B.Tech - Artificial Intelligence in Amity University Lucknow Campus. This is my official Portfolio website to showcase my all works and
              projects related to my studies. Here you can see the projects i
              created, feel free to have a look and explore.
            </p>
            <div style={{ display: "flex" }}>
              <Button
                href="https://drive.google.com/file/d/1smNV0zCESrTiAaS--4nZjQIrKUsHxF26/view?usp=sharing"
                className="dcv"
                variant="contained"
                color="primary"
              >
                Download CV
              </Button>
              <Link to={"/certificates"}>
              <Button
                style={{ marginLeft: "15px" }}
                className="dcv"
                variant="contained"
              >
                My Achievements
              </Button>
              </Link>
            </div>
          </div>
        </Fade>
        <Zoom top>
          <div style={theme1} className="imagemy">
            <a href="https://vishnu305.github.io/mysite1/">
              <img style={{ zIndex: "2" }} id="myimage" src={propic} />
            </a>
          </div>
        </Zoom>
      </Info>
      <Aboutme id="2">
        <Zoom top>
          <div className="image1">
            <Link to={"/aboutme"}>
              <img style={{ zIndex: "2" }} class="aboutimg" src={about} />
            </Link>
          </div>
          <div className="content1">
            <h1>Click on the Image to know a little bit about Me🙂</h1>
          </div>
        </Zoom>
      </Aboutme>
      <Projects id="3">
        <Zoom top>
          <div className="image2">
            <Link to={`/projects/#11`}>
              <img style={{ zIndex: "2" }} src={projects} />
            </Link>
            <p>Click the above image to see my Projects</p>
          </div>
          <div className="image3">
            <Link to={"/education"}>
              <img style={{ zIndex: "2" }} className="projimg" src={qual} />
            </Link>
            <p>Click the above image to see my Qualifications</p>
          </div>
        </Zoom>
      </Projects>

      <Footer>
        <a
          style={{ zIndex: "200" }}
          class="footer-link"
          href="https://www.linkedin.com/in/divvela-vishnu-sai-kumar-868b871b9/"
        >
          LinkedIn
        </a>
        <a
          style={{ zIndex: "200" }}
          class="footer-link"
          href="https://github.com/vishnu305"
        >
          Github
        </a>
        <a
          style={{ zIndex: "200" }}
          class="footer-link"
          href="https://www.youtube.com/channel/UC8N_xtS5BFOfNWFZgcn-Jfg/videos"
        >
          Youtube
        </a>
        <p style={{ color: "white" }}>© 2021 Vishnu Divvela.</p>
      </Footer>
    </Container>
  );
}

export default Header;
const Projects = styled.div`
  width: 100%;
  margin-top: 250px;
  /* background: white; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  img {
    width: 450px;
    border: 5px solid black;
    cursor: pointer;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    &:hover {
      box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
      border-color: rgba(249, 249, 249, 0.8);
      transform: scale(1.05);
    }
  }
  p {
    font-size: 20px;
    font-weight: bolder;
  }
  .image2 {
    margin-left: 100px;
  }
  .image3 {
    margin-right: 100px;
  }
  @media screen and (max-width: 780px) {
    display: block;
    margin-top: 100px;
    .image2 {
      margin-left: 3%;
      img {
        width: 80%;
      }
    }
    .image3 {
      margin-left: 15%;
      img {
        width: 110%;
      }
    }
  }
`;
const Aboutme = styled.div`
  /* background:white; */
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  img {
    width: 500px;
    margin-top: 250px;
    margin-left: 100px;
    border-radius: 20px;
    border: 5px solid black;
    cursor: pointer;
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
    &:hover {
      box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
        rgb(0 0 0 / 72%) 0px 30px 22px -10px;
      border-color: rgba(249, 249, 249, 0.8);
      translatex: scale(1.2);
    }
  }
  h1 {
    padding-top: 220px;
    text-align: right;
  }
  @media screen and (max-width: 780px) {
    .aboutimg {
      margin-left: 0;
      width: 80%;
      margin-top: 140px;
    }
    .content1 {
      width: 100%;
      display: block;
      text-align: center;
      margin-top: 0;
      padding-top: 0px;
      h1 {
        text-align: center;
        padding-top: 20px;
        margin-left: 4%;
      }
    }
  }
`;

const Container = styled.div`
  /* cursor: grab; */
  /* --primary-color: linear-gradient(to right, #ddd6f3, #faaca8);
--secondary-color: #212121; */
  /* height: 150vh; */
  width: 100%;
  /* background: #edf2fc; */
  /* background: linear-gradient(to right, #ddd6f3, #faaca8); */
  /* background: var(--primary-color); */
  position: relative;
  #cursor {
    height: 50px;
    width: 50px;
    background: #e7c82f;
    border-radius: 50%;
    position: absolute;
    display: none;
    transition-duration: 0.2s;
    transition-timing-function: easeout;
    z-index: 1;
  }
`;
const Navbar = styled.div`
  width: 100%;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  margin: auto;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  --secondary-color: #212121;
  transition: all 0.3s ease;
  h2 {
    /* color: var(--secondary-color); */
    margin-left: 8%;
    margin-top: 28px;
    @media screen and (max-width: 780px) {
      margin-top: 50px;
    }
  }
  ul {
    flex: 1;
    text-align: right;
    margin-right: 5%;
    // font-weight: bold;
    font-size: 16px;
    li {
      display: inline-block;
      list-style: none;
      // margin: 10px 13px;
      margin-left: 13px;
      margin-right: 13px;
      margin-bottom: 10px;
      margin-top: 0px;

      a {
        text-decoration: none;
        /* color: var(--secondary-color); */
        span {
          letter-spacing: 1.42px;
          position: relative;
          color: white;

          &:after {
            content: "";
            height: 2px;
            /* background: var(--secondary-color); */
            background: white;
            position: absolute;
            left: 0;
            right: 0;
            bottom: -6px;
            opacity: 0;
            transform-origin: left center;
            transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
            transform: scaleX(0);
          }
        }
        &:hover {
          color: #ff4321;
          color: white;
          span:after {
            transform: scaleX(1);
            opacity: 1;
          }
        }
      }
    }
  }
  .icon {
    width: 30px;
    cursor: pointer;
  }
  @media screen and (max-width: 780px) {
    position: fixed;
    z-index: 1;
    height: 60px;
  }
`;
const Info = styled.div`
  --secondary-color: #212121;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .content {
    flex: 0.5;
    margin-left: 9%;
    margin-top: 12%;
    h1 {
      font-size: 50px;
      /* color: var(--secondary-color); */
      width: 105%;
      text-align: left;
      margin-bottom: 20px;
      span {
        color: #ff4321;
      }
    }
    p {
      /* color:#606163; */
      /* color: var(--secondary-color); */
      line-height: 30px;
      font-size: 23px;
      text-align: left;
      margin-left: 0%;
    }
    .dcv {
      font-size: 18px;
      margin-top: 35px;
      // display: flex;
      // width: 60%;
      /* flex:1; */
      /* justify-content:flex-start; */
    }
    @media screen and (max-width: 780px) {
      .dcv {
        display: inline-block;
      }
    }
  }
  .imagemy {
    flex: 0.5;
    border-radius: 10px;
    img {
      cursor: pointer;
      margin-left: 250px;
      margin-top: 180px;
      height: 60vh;
      transform: translateX(-50%);
      border: 3px solid rgba(249, 249, 249, 0.1);
      border: 3px solid var(--secondary-color);

      box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
        rgb(0 0 0 / 73%) 0px 16px 10px -10px;

      transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
      &:hover {
        box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
          rgb(0 0 0 / 72%) 0px 30px 22px -10px;
        border-color: rgba(249, 249, 249, 0.8);
        /* background-color: linear-gradient(#fb0094,#0000ff, #00ff00,#ffff00,#ff0000,#fb0094,#0000ff, #00ff00,#ffff00,#ff0000); */
      }
    }
  }
  @media screen and (max-width: 780px) {
    display: block;
    width: 90%;
    .content {
      /* width: 100%; */
      padding-top: 10px;
      h1 {
        /* width:90%; */
        padding-top: 100px;
        padding-left: 0;
        text-align: center;
      }
      p {
        /* width:80%; */
        text-align: center;
      }
      .my11 {
        padding-top: 10px;
      }
    }
  }
`;
const Footer = styled.div`
  margin-top: 100px;
  padding-bottom: 10px;
  background-color: #66bfbf;
  background: #243b55;
  position: sticky;
  .footer-link {
    z-index: 2;
    color: #11999e;
    display: inline-block;
    margin: 10px 20px;
    text-decoration: none;
  }
  .footer-link::after {
    content: "";
    display: block;
    width: 0;
    height: 2px;
    background: red;
    transition: width 0.3s;
  }

  .footer-link:hover::after {
    width: 100%;
    transition: width 0.3s;
  }
  .footer-link:hover {
    color: white;
  }
`;
